module.exports = __webpack_public_path__ + "img/in-house.118085fa.png";